// extracted by mini-css-extract-plugin
module.exports = {"SplashScreen":"SplashScreen__SplashScreen___34Vrr","SplashLogoWrapper":"SplashScreen__SplashLogoWrapper___1Ze8U","glow":"SplashScreen__glow___1zm4w"};